import React from "react";
import { endpoint } from "../../../../../manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import moment from "moment";
import { phoenixPaymentBaseUrl } from "services/http";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

export const fetchAdvancePaymentDetail = async (
  type = "all",
  psid,
  applicationId,
  setAdvancePaymentDetail,
  setLoader
) => {
  const jodoUrl = endpoint.paymentCollection.getJodoPaymentCollectionDetails;
  const url =
    type == "jodo"
      ? jodoUrl
      :type == "tribyte" ? `${endpoint.getTribyteSuncLogs}/${applicationId}`
      : `${endpoint.paymentDetails}?type=${type}&psid=${psid}&applicationId=${applicationId}`;
  const req = {
    psid,
    applicationId,
  };
  setLoader(true);
  try {
    const res =
      type == "jodo"
        ? await fetchAllPostPromisedData(url, req)
        : await fetchAllPromisedData(url, true);

    if (res?.code == 200) {
      if (Array.isArray(res?.data)) {
        const rowData = (res?.data).map((item, index) => ({
          ...item,
          id: index + 1,
        }));
        setAdvancePaymentDetail(rowData);
      } else if (type == "salesforce") {
        const data = [
          {
            type: "Salesforce account ID",
            id: res?.data?.sfAccountId,
            createdOn: res?.data?.sfAccountIdCreatedOn,
            ownerId: res?.data?.ownerId,
          },
          {
            type: "Salesforce opportunity ID",
            id: res?.data?.sfOpportunityId,
            createdOn: res?.data?.sfOpportunityIdCreatedOn,
            ownerId: res?.data?.ownerId,
          },
          {
            type: "Salesforce receipt ID",
            id: res?.data?.sfReceiptId,
            createdOn: res?.data?.sfReceiptIdCreatedOn,
            ownerId: res?.data?.ownerId,
          },
        ];
        setAdvancePaymentDetail(data);
      } else setAdvancePaymentDetail(res?.data);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoader(false);
  }
};

export const getReinitiate = async (
  data,
  setLoader,
  setOpen,
  setDate,
  getPaymentDetail
) => {
  try {
    setLoader(true);
    const url = `${phoenixPaymentBaseUrl}/jodo/students/${data?.jodoStudentId}/reschedule`;
    const req = {
      due_date: data?.newDueDate,
      new_due_date: data?.date ? moment(data?.date).format("YYYY-MM-DD") : null,
    };
    const res = await fetchAllPostPromisedData(
      url,
      req,
      "post",
      false,
      "",
      "",
      true
    );

    setOpen(null);
    setDate(null);
    if (res?.code == 200) {
      successToast("Represented Successfully");
      getPaymentDetail("jodo");
    } else failureToast("Failed to Represent");
  } catch (error) {
  } finally {
    setLoader(false);
  }
};

export const getCoursePricingDetails = async (courseId, businessArea, term,setLoader) => {
  if (!courseId || !businessArea || !term) return {};
  const reqBody = {
    courseId,
    businessArea,
    term,
  };
  try{
    setLoader(true)
  const res = await fetchAllPostPromisedData(
    endpoint?.course?.getCoursePricingDetails,
    reqBody,
    "post"
  );
  return res?.data;
}
catch(err){
  console.log(err)
}
finally{
  setLoader(false)
}
};


